import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { RouteList } from "./routes";

import "react-toastify/dist/ReactToastify.css";
import "assets/fonts/index.scss";
import "./App.scss";

import { ModalProvider } from "context/ModalContext";
import ToastProvider from "context/ToastContext";
import { AppContainer } from "components/ui/app-container";
import TagManager from "react-gtm-module";
import { HelmetProvider } from "react-helmet-async";

const tagManagerArgs = {
  gtmId: "G-Q3S7R9H1P0",
};
TagManager.initialize(tagManagerArgs);

(window as any).dataLayer.push({
  event: "pageview",
});

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <ModalProvider>
          <AppContainer>
            <RouteList />
          </AppContainer>
          <ToastProvider />
        </ModalProvider>
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
